import React, { Component } from "react";
import LearnLayout from "../components/LearnLayout";
import Code from "../components/Code";

class Learn_intro extends Component {
  render() {
    let code = `std::cout<<"HELLO WORLD";`;
    return (
      <LearnLayout>
        <Code>{code}</Code>
      </LearnLayout>
    );
  }
}

export default Learn_intro;
